module.exports = __webpack_public_path__ + "img/V22.3963f898.png";